import React from 'react'
import { Pago } from './views/pago/Pago';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import TabView from './views/tab/TabView';

const App = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="multipagos/:token/:idacceso"  element={<Pago />} />
          <Route path="*" element={<Pago />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
